import { FeatureFlags } from "../types/featureFlags.types";

// CRA only inlines REACT_APP_* vars where they're accessed as a literal `process.env.REACT_APP_X`
// (webpack statically replaces that exact expression) - a dynamic/computed lookup would not be
// replaced and would be undefined in the built bundle, so each flag's env var must be read
// explicitly here rather than looped over.
//
// Flags are read at build time, so they're configured per environment (dev/test/prod) by setting
// the matching REACT_APP_FEATURE_* var in that environment's build, same as the Cognito config in
// auth.config.tsx. There's no runtime link to the backend services a flag depends on - flip a flag
// on in an environment once the backend feature it depends on is actually deployed there.
const rawFlagValues: Record<keyof FeatureFlags, string | undefined> = {
  emailGenerator: process.env.REACT_APP_FEATURE_EMAIL_GENERATOR,
  callsExplorer: process.env.REACT_APP_FEATURE_CALLS_EXPLORER,
};

// Defaults apply when a flag's env var is unset (e.g. a local .env that predates the flag). A flag
// retrofitted onto an already-live tool should default "on" so introducing it never silently hides
// something that already shipped; a flag introduced for new/in-development work should default
// "off" instead, so merging its code never exposes it until an environment turns it on explicitly.
const flagDefaults: FeatureFlags = {
  emailGenerator: true,
  callsExplorer: false,
};

const parseFlag = (value: string | undefined, fallback: boolean): boolean =>
  value === undefined || value === "" ? fallback : value.toLowerCase() === "true";

export const featureFlags: FeatureFlags = Object.keys(flagDefaults).reduce((acc, key) => {
  const flagKey = key as keyof FeatureFlags;
  acc[flagKey] = parseFlag(rawFlagValues[flagKey], flagDefaults[flagKey]);
  return acc;
}, {} as FeatureFlags);

export const isFeatureEnabled = (key: keyof FeatureFlags): boolean => featureFlags[key];
